export default __webpack_public_path__ + "static/media/Itim-Regular.f70e0d25.ttf";